export const PAGE_SIZE: number = 20;
export const SUMMARIZATION_MODEL: string = "google/gemini-3-flash";
export const EXPLORE_MODEL: string = "deepseek/deepseek-v4-flash";
